// Fetches AuditLogger V1 install count from API
export async function fetchAuditLoggerV1GuildCount(): Promise<number | null> {
  try {
    const response = await fetch('/api/auditlogger/guild_count');
    if (!response.ok) throw new Error('Failed to fetch AuditLogger V1 guild count');
    const data = await response.json();
    // Expecting { guild_count: number }
    return typeof data.guild_count === 'number' ? data.guild_count : null;
  } catch (err) {
    console.error('Error fetching AuditLogger V1 guild count:', err);
    return null;
  }
}
